// import './helpers.css';

import { useState, useContext, useEffect } from 'react';

import { IconBut } from './ui/buttons';


export function PopUp({ children, show }) {

    return (
        <div className={`popup-window ${!show ? "close" : ''}`}>
            <div className="container">
                <div className="heading fw">
                    <IconBut className="fa-solid fa-xmark lg" />
                    <div>
                        <div className="notch"></div>
                    </div>
                </div>
                <div className="content custom-scroll">
                    {children}
                </div>
            </div>
        </div>
    )
}



export function Slider({ children, length, pagn }) {
    const [active, setActive] = useState(0);
    const [startX, setStartX] = useState(null);

    function handleTouchStart(ev) {
        setStartX(ev.touches[0].clientX)
    }

    function handleTouchMove(ev) {
        // let dX = startX - ev.touches[0].clientX;
    }

    function slide(dir) {
        if (dir === "left") {
            // move slider left
            setActive(active === length - 1 ? 0 : active + 1)

        } else if (dir === "right") {
            // move slider right
            setActive(active === 0 ? length - 1 : active - 1)
        } else {
            // setActive(active === 2? 0 : active + 1) : setActive(active === 0? 2 : active - 1);
        }
    }

    function handleTouchEnd(ev) {
        let threshold = 100;
        let dX = startX - ev.touches[0].clientX;

        slide(Math.abs(dX) > threshold ? dX > threshold ? "left" : "right" : undefined)
    }

    return (
        <>
            <div className="flex" onTouchStart={handleTouchStart} onTouchMoveCapture={handleTouchMove} onTransitionEnd={handleTouchEnd}>
                <IconBut className="fa-solid fa-angle-left" onclick={_ => slide("left")} />
                {children}
                <IconBut className="fa-solid fa-angle-right" onclick={_ => slide("right")} />
            </div>
            {pagn ?
                <div className="pgnn flex">
                    {Array(length).map((_, i) => <div className={active === i ? "active" : ""} key={i}></div>)}
                </div>
                :
                <></>
            }
        </>
    )
}

export function Overlay({ name, children }) {


    return (
        <div className="overlay fw abs" style={{ minHeight: "100vh" }}>
            <div className='content max'>
                {children}
            </div>
        </div>
    )
}


export function getCookie(name) {
    const cookies = document.cookie.split(';')
    for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.startsWith(name + '='))
            return cookie.substring(name.length + 1)
    }
    return null
}

export function StoreCookies(cookies) {
    cookies.forEach(({ name, value, httpsOnly, domain }) => {
        document.cookie = `${name}=${encodeURIComponent(value)}; path=${domain ?? '/'}; ${httpsOnly ? "secure;" : ""}`
    })
}

export function AuthRequest(url, options) {
    let refreshToken = getCookie("refresh"), accessToken = getCookie("access");

    const headers = {
        access: "JWT" + accessToken,
        refresh: "JWT" + refreshToken
    }

    return fetch(url, { ...options, headers: headers })
}